import { render, staticRenderFns } from "./kpsrImpr.vue?vue&type=template&id=42f746d4"
import script from "./kpsrImpr.vue?vue&type=script&lang=js"
export * from "./kpsrImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f746d4')) {
      api.createRecord('42f746d4', component.options)
    } else {
      api.reload('42f746d4', component.options)
    }
    module.hot.accept("./kpsrImpr.vue?vue&type=template&id=42f746d4", function () {
      api.rerender('42f746d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/risk/kpsrImpr.vue"
export default component.exports